import { render, staticRenderFns } from "./periodos.vue?vue&type=template&id=d33665be"
import script from "./periodos.vue?vue&type=script&lang=js"
export * from "./periodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports